import { GeneratedSchedugramServerClient } from "./generated-schedugram-server-client";
import type { paths } from "./generated/schedugram-server-openapi-types";

const generatedSchedugramServerClient =
  new GeneratedSchedugramServerClient<paths>();

export const getMentions = async (query: string) => {
  const result = await generatedSchedugramServerClient.client.GET(
    "/tags/mentions/{prefix}",
    {
      params: {
        path: { prefix: query },
      },
    }
  );

  return generatedSchedugramServerClient.unwrap<unknown>(result);
};

export const getInstaPopularUsers = async (accountId: string) => {
  const result = await generatedSchedugramServerClient.client.GET(
    "/instagram-api/{accountId}/user-info",
    {
      params: {
        path: { accountId },
      },
    }
  );

  return generatedSchedugramServerClient.unwrap<unknown>(result);
};

export const getInstaUser = async (accountId: string, userName: string) => {
  const result = await generatedSchedugramServerClient.client.GET(
    "/instagram-api/{accountId}/user-info/{userName}",
    {
      params: {
        path: { accountId, userName },
      },
    }
  );

  return generatedSchedugramServerClient.unwrap<unknown>(result);
};
